import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type PlayingCardStatus = 'idle' | 'loading' | 'playing';

export interface AudioStore {
  isPlaying: boolean; // 音频是否正在播放
  targetMsgId: string; // 目标卡片的msgId
  targetStatus: PlayingCardStatus; // 目标卡片的播放UI状态
  audioUrlList: string[]; // 音频资源列表
  currentIndex: number; // 资源列表播放index
  requestFinished: boolean; // 资源列表是否请求完毕
  timbre: string; // 音色
  beforeIndex: number; // 之前的index
  beforeMsgId: string; // 之前的msgId
  beforeTime: number; // 之前的msgId
  isAutoPlay: boolean; // 是否自动播放
  playSpeedLevel: number; // 播放的速度
}

const initialState: AudioStore = {
  isPlaying: false,
  targetMsgId: '',
  targetStatus: 'idle',
  audioUrlList: [],
  currentIndex: 0,
  requestFinished: false,
  timbre: '',
  beforeIndex: 0,
  beforeMsgId: '',
  beforeTime: 0,
  isAutoPlay: false,
  playSpeedLevel: 1.0 as number,
};

export const audioSlice = createSlice({
  name: 'audio',
  initialState,
  reducers: {
    clearAudioStore: (state) => {
      return {
        ...initialState,
        timbre: state.timbre, // 音色不清空
        beforeIndex: state.beforeIndex,
        beforeMsgId: state.beforeMsgId,
        beforeTime: state.beforeTime,
        isAutoPlay: state.isAutoPlay, // 自动播放状态不清空
        playSpeedLevel: state.playSpeedLevel, // 播放速度不清空
      };
    },
    clearBeforeStore: (state) => {
      return {
        ...state,
        beforeIndex: 0,
        beforeMsgId: '',
        beforeTime: 0,
      };
    },
    setBeforeAudioStore: (state) => {
      return {
        ...state,
        beforeIndex: state.currentIndex,
        beforeMsgId: state.targetMsgId,
      };
    },
    setBeforeTime: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        beforeTime: action.payload,
      };
    },
    setIsPlaying: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isPlaying: action.payload,
      };
    },
    setTargetMsgId: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        targetMsgId: action.payload,
      };
    },
    setTargetStatus: (state, action: PayloadAction<PlayingCardStatus>) => {
      return {
        ...state,
        targetStatus: action.payload,
      };
    },
    setAudioUrlList: (state, action: PayloadAction<string[]>) => {
      return {
        ...state,
        audioUrlList: action.payload,
      };
    },
    setCurrentIndex: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        currentIndex: action.payload,
      };
    },
    setRequestFinished: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        requestFinished: action.payload,
      };
    },
    setTimbre: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        timbre: action.payload,
      };
    },
    setIsAutoPlay: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isAutoPlay: action.payload,
      };
    },
    setPlaySpeedLevel: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        playSpeedLevel: action.payload,
      };
    },
  },
});

export const {
  clearAudioStore,
  clearBeforeStore,
  setBeforeAudioStore,
  setIsPlaying,
  setTargetMsgId,
  setTargetStatus,
  setAudioUrlList,
  setCurrentIndex,
  setBeforeTime,
  setRequestFinished,
  setTimbre,
  setIsAutoPlay,
  setPlaySpeedLevel,
} = audioSlice.actions;

export default audioSlice.reducer;
